import { AuthenticationLogic } from './authTypes';
import { useAuthLifecycle } from './authLifecycle';
import { useAuthPrimaryActions } from './authPrimaryActions';
import { useAuthSecondaryActions } from './authSecondaryActions';

export function useAuthenticationLogic(): AuthenticationLogic {
  const {
    authState,
    setAuthState,
    apiClient,
    refreshAccessToken,
    createGuestSession,
    resetGuestCreationAttempt,
  } = useAuthLifecycle();

  const primaryActions = useAuthPrimaryActions({
    authState,
    setAuthState,
    apiClient,
    createGuestSession,
    resetGuestCreationAttempt,
  });

  const secondaryActions = useAuthSecondaryActions({
    setAuthState,
    apiClient,
    refreshAccessToken,
    logout: primaryActions.logout,
  });

  return {
    ...authState,
    apiClient,
    ...primaryActions,
    ...secondaryActions,
    createGuestSession,
  };
}
